module.exports = __webpack_public_path__ + "static/media/contact-akshay.16e93912.jpg";